import { styled } from 'styled-components';

export const PlayerBioStatsRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizing.medium} 5rem;
  flex-direction: row;
  padding: ${({ theme }) => theme.sizing.medium};
  flex-wrap: wrap;
  border-top: ${({ theme, $border }) =>
    `${$border || 0}px solid ${theme.colours.canvas.secondary.main}`};
`;
PlayerBioStatsRow.displayName = 'PlayerBioStatsRow';

export const PlayerBioStatWrapper = styled.div`
  color: ${({ theme }) => `${theme.colours.ink.primary.main}`};
  width: auto;

  h4 {
    ${({ theme }) => theme.typography.bodySmall}
    color: ${({ theme }) => `${theme.colours.ink.primary.main}80`};
  }
`;
PlayerBioStatWrapper.displayName = 'PlayerBioStatWrapper';

export const PlayerBioStat = styled.div`
  ${({ theme }) => theme.typography.headingRegular}
  font-weight: 400;

  ul {
    li {
      display: inline;
    }

    li + li {
      margin-left: ${({ theme }) => theme.sizing.regular};
    }
  }

  span.stars {
    float: left;
    margin-right: ${({ theme }) => theme.sizing.small};
    margin-left: -2px;
    line-height: 1.3;
  }
`;
PlayerBioStat.displayName = 'PlayerBioStat';
